import { combineReducers } from "redux";
import authentication from "../Login/Reducer";
import kitchen from "../Kiosk/Reducer/KitchenReducer";
import landing from "../Landing/Reducer";
import foodmaking from '../Kiosk/Reducer/FoodmakingReducer'
import inventory from "../Inventory/Reducer/index";
import cookBook from "../CookBook/Reducer";
import orders from "../Orders/Reducers";
import task from "../Tasks/reducers/taskReducer"

const reducers = combineReducers({
    landing,
    authentication, 
    kitchen,
    foodmaking,
    inventory,
    cookBook,
    orders,
    task
});

export default reducers;